import { Box, Button, Divider, Grid, List, ListItem, ListItemIcon, makeStyles, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useView } from '../../utility/services/uiHelpers';
import { VerifyEmailComponent } from '../content-ai-tools/components/VerifyEmailComponent';
import Cookies from 'js-cookie';
import VerifyToolsUser from '../content-ai-tools/components/VerifyToolsUser';

const CONTINUE_USING_TEXT = 'continue using Quattr';

const ToolsOnboardingWrapper = ({ classes, handleChangePlan }) => {
  let qttr_tools_auth = Cookies.get('qttr_tools_auth');
  let use_locked_grace = Cookies.get('use_locked_grace');

  const [showVerifyEmailPopup, setShowVerifyEmailPopup] = useState(false);
  const [toolMeta, setToolMeta] = useState({});
  const [showSignUpPage, setShowSignUpPage] = useState('');
  const [showBuyOnePass, setShowBuyOnePass] = React.useState(false);
  const [showBuyOnePassSuccess, setShowBuyOnePassSuccess] = React.useState(false);
  const [showSuccessEmailVerification, setShowSuccessEmailVerification] = React.useState(false);

  const isMobile = useView('mobileOnly');
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // This makes the scrolling smooth. Remove it if you want instant scroll.
    });
  };

  return (
    <Grid container className={classes.root}>
      <div className={classes.overallToolsWrapper}>
        <div className={classes.topHeadingsWrapper}>
          <Typography variant="h1" className={classes.topHeading}>
            Quattr AI Tool Library
          </Typography>
          <Typography variant="h3" className={classes.topSubHeading}>
            The Go-to Resource for Fast, High Quality AI Content
          </Typography>
        </div>
        <Grid container className={classes.root} style={{ height: 'auto', marginTop: isMobile ? '3vh' : '5vh' }}>
          <Grid item xs={12} md={6} className={classes.sectionTwo}>
            {/* write your code here */}
            <svg xmlns="http://www.w3.org/2000/svg" width="91" height="95" viewBox="0 0 91 95" fill="none">
              <path
                d="M19.0957 74.6656L24.4628 60.9711C8.80246 50.6488 2.12297 55.7295 1.38893 57.2349C-1.28043 62.7095 13.7346 71.4497 19.0957 74.6656Z"
                fill="white"
                stroke="#1D3557"
              />
              <path
                d="M56.4239 46.4347C44.5006 46.9933 32.8222 51.4933 24.9634 56.6747C18.1416 61.1723 16.1689 69.7368 19.9495 76.9806C25.148 86.9409 36.2249 98.4295 56.8377 92.6804C69.5711 89.1289 75.5464 79.8552 77.6222 70.3739C80.4506 57.4549 69.6344 45.8158 56.4239 46.4347Z"
                fill="white"
                stroke="#1D3557"
              />
              <path
                d="M71.8489 70.8069L76.5667 57.2969C91.6635 68.2764 90.5055 75.5247 89.4333 76.8113C85.5342 81.4903 75.8518 73.9521 71.8489 70.8069Z"
                fill="white"
                stroke="#1D3557"
              />
              <path
                d="M23.4501 12.0531C23.2856 11.507 23.1418 10.9987 23.0072 10.4932C22.7408 9.49259 23.9943 8.85214 24.645 9.65757C24.979 10.071 25.3105 10.496 25.6614 10.9633C26.0414 11.4693 25.8465 12.1938 25.2693 12.4531L24.8028 12.6626C24.2589 12.907 23.6221 12.6241 23.4501 12.0531Z"
                fill="#1D3557"
              />
              <ellipse
                cx="44.5346"
                cy="60.7735"
                rx="25.5186"
                ry="8.58149"
                transform="rotate(-15.0901 44.5346 60.7735)"
                fill="#A5D7D9"
              />
              <path
                d="M32.7604 81.3651C33.5146 86.2988 35.2623 89.6883 36.4658 91.8217C42.2558 93.7517 53.6214 95.2529 66.0591 87.7473C65.0508 85.1898 64.245 82.9739 63.5026 80.7148C61.5893 74.8928 55.2019 71.7777 49.3134 73.4752C44.6641 74.8155 40.5421 75.5916 37.3729 75.9993C34.6341 76.3517 32.3432 78.6354 32.7604 81.3651Z"
                fill="#51D597"
              />
              <path
                d="M45.6787 55.511C61.0208 50.0413 69.9633 35.2912 65.387 22.4553C60.8108 9.61944 44.554 3.85332 29.2118 9.32308C13.8697 14.7928 4.92727 29.5429 9.50349 42.3788C14.0797 55.2147 30.3365 60.9808 45.6787 55.511Z"
                fill="#51D597"
                stroke="#1D3557"
              />
              <path
                d="M14.3779 35.9233C14.3779 24.0642 24.6969 18.4781 29.3673 16.3561C34.0376 14.2341 46.3998 9.63506 55.0556 17.7217C59.0086 21.6849 64.6184 31.7898 52.3948 37.3937C50.3201 38.1365 47.2594 38.9927 44.3566 39.8764C41.0432 40.9832 34.3637 45.4106 30.5506 47.3871C18.1253 52.526 14.5752 41.5234 14.3779 35.9233Z"
                fill="white"
                stroke="#1D3557"
              />
              <circle cx="24.2423" cy="36.2813" r="6.29111" stroke="#51D597" stroke-width="2" />
              <circle cx="47.4024" cy="25.9879" r="6.29111" stroke="#51D597" stroke-width="2" />
            </svg>
            <Typography variant="h1" className={classes.sectionTwoMainHeading}>
              Unlock Success with Quattr’s AI Tools{' '}
            </Typography>

            <List className={classes.featureList}>
              <ListItem className={classes.featureItem}>
                <ListItemIcon className={classes.CheckCircleListItemIcon}>
                  <CheckCircleIcon className={classes.featureIcon} />
                </ListItemIcon>
                <Typography variant="body1" className={classes.featureItemText}>
                  AI SEO Tools - Title Generator & more...
                </Typography>
              </ListItem>
              <ListItem className={classes.featureItem}>
                <ListItemIcon className={classes.CheckCircleListItemIcon}>
                  <CheckCircleIcon className={classes.featureIcon} />
                </ListItemIcon>
                <Typography variant="body1" className={classes.featureItemText}>
                  AI Writing Tools like Active-Passive Converter, Paragraph Generator & more...
                </Typography>
              </ListItem>
              <ListItem className={classes.featureItem}>
                <ListItemIcon className={classes.CheckCircleListItemIcon}>
                  <CheckCircleIcon className={classes.featureIcon} />
                </ListItemIcon>
                <Typography variant="body1" className={classes.featureItemText}>
                  AI Optimization Tools - Heading Rewriter & more..{' '}
                </Typography>
              </ListItem>
              <ListItem className={classes.featureItem}>
                <ListItemIcon className={classes.CheckCircleListItemIcon}>
                  <CheckCircleIcon className={classes.featureIcon} />
                </ListItemIcon>
                <Typography variant="body1" className={classes.featureItemText}>
                  3 Powerful Keyword Research Tools{' '}
                </Typography>
              </ListItem>
            </List>
            <Typography variant="body1" className={classes.brandsHeading}>
              100K+ Users are Generating Content with Quattr AI Tools{' '}
            </Typography>
            <Box className={classes.brandLogosContainer}></Box>
          </Grid>
          <Grid item xs={12} md={6} className={classes.sectionOneForToolsWrapper}>
            <VerifyToolsUser showStepper={false} handleChangePlan={handleChangePlan} />
          </Grid>
        </Grid>

        {/* {isMobile && (
          <div className="center-align" style={{ margin: '3vh 0px' }}>
            <Button onClick={() => scrollToTop()} className={classes.startFreeTrial}>
              Start With AI Tools
            </Button>
          </div>
        )} */}
      </div>
    </Grid>
  );
};

export default ToolsOnboardingWrapper;
